import React, { useState, useEffect, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';

import AuthContext from '../../store/auth-context';
import { useFormatDateAndTime } from '../Hooks/useFormatDateAndTime';
import WorkflowMessage from '../UI/WorkflowMessage';
import classes from '../CSS/styled-table.module.css';

const NewTeams = () => {
  const authCtx = useContext(AuthContext);
  const dashboardUrl = authCtx.dashboardUrl;

  const history = useHistory();

  const [teams, setTeams] = useState([]);
  const [displayedTeams, setDisplayedTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const { FormatDateAndTimeForDisplay } = useFormatDateAndTime();

  useEffect(() => {
    setIsLoading(true);
    // declare the async data fetching function
    const fetchData = async () => {
      // get the data from the api
      const response = await fetch(authCtx.baseApiUrl + 'teams/status/new', {
        headers: {
          Authorization: authCtx.token,
          'Content-Type': 'application/json',
        },
      });

      // console.log(response);

      const responseData = await response.json();

      if (response.ok) {
        // console.log(' -- response.ok -- ');
        // console.log(responseData.data.teams);

        const transformedTeams = responseData.data.teams.map((team) => {
          return {
            teamUuid: team.teamUuid,
            name: team.name,
            description: team.description,
            league: team.league,
            status: team.status,
            dateAddedFormatted: team.dateAdded ? FormatDateAndTimeForDisplay(team.dateAdded) : '',
          };
        });

        setTeams(transformedTeams);
        setDisplayedTeams(transformedTeams);
      } else {
        // If a 401 is returned then there is an issue with the session (most likely).
        if (responseData.statusCode === 401) {
          history.push(dashboardUrl + 'sessionexpired');
        }

        setIsError(true);
      }
      setIsLoading(false);
    };

    // call the function
    fetchData().catch(console.error);
  }, [authCtx.baseApiUrl, authCtx.token, dashboardUrl, history, FormatDateAndTimeForDisplay]);

  const displayTableHeader = () => {
    return (
      <tr>
        <th>Date</th>
        <th>Name</th>
        <th>League</th>
        <th>Actions</th>
      </tr>
    );
  };

  const displayTableBody = () => {
    return displayedTeams.map((team, index) => (
      <tr key={index}>
        <td>{team.dateAddedFormatted}</td>
        <td>{team.name}</td>
        <td>{team.league}</td>
        <td>
          <div className={classes['table-actions-container']}>
            <Link to={`${dashboardUrl}team/approval/${team.teamUuid}`} className='button small'>
              Approve
            </Link>
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <>
      <Typography variant='h2' component='h2'>
        New Team Approvals
      </Typography>

      {isLoading ? <WorkflowMessage type='loading' /> : null}
      {isError ? <WorkflowMessage type='error' /> : null}
      {!isLoading && !isError && teams.length === 0 ? (
        <WorkflowMessage type='nodata' message='No New Team Approvals...' alignText='left' />
      ) : null}

      {!isLoading && !isError && teams.length > 0 ? (
        <div className='table-holder'>
          <table className={`${classes['styled-table']} ${classes['full-width']}`}>
            <thead>{displayTableHeader()}</thead>
            <tbody>{displayTableBody()}</tbody>
          </table>
        </div>
      ) : null}
    </>
  );
};

export default NewTeams;
